// assets/print-article.js
class ArticlePrinter {
  constructor() {
    this.printButton = document.querySelector('.print-recipe-button');
    if (this.printButton) {
      this.printButton.addEventListener('click', (e) => this.handlePrintClick(e));
    }
  }

  handlePrintClick(e) {
    e.preventDefault();
    this.printArticleContent();
  }

  printArticleContent() {
    const containers = document.querySelectorAll('.article-sidebar-container');
    if (!containers.length) return;

    const printWindow = window.open('', 'PRINT', 'height=650,width=900');
    
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Recipe</title>
          <meta charset="utf-8">
          <style>
            @page { size: auto; }
            body { 
              margin: 0; 
              padding: 0; 
              font: 12pt/1.5 Arial, sans-serif;
              color: #000;
            }
            .print-content { 
              width: 100%; 
              page-break-inside: avoid; 
            }
            article-pagination { display: none !important; }
            img { 
              max-width: 100%; 
              max-height: 300px; 
              max-width:700px;
              width: auto;
              height: auto;
              object-fit: cover;
              object-position: center;
              display: block;
              margin: 0 auto;
            }
          
            @media print {
              img {
                max-height: 300px !important;
              }
                button{
            display:none !important;
            }
            }
          </style>
        </head>
        <body>
    `);

    containers.forEach(container => {
      const clone = container.cloneNode(true);
      clone.querySelector('article-pagination')?.remove();
      printWindow.document.write(`<div class="print-content">${clone.innerHTML}</div>`);
    });

    printWindow.document.write('</body></html>');
    printWindow.document.close();

    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      setTimeout(() => printWindow.close(), 100);
    }, 300);
  }
}

document.addEventListener('DOMContentLoaded', () => new ArticlePrinter());